import Vue from "vue";
import VueRouter from "vue-router";
import SecureStorage from '@/utils/secureStorage';

Vue.use(VueRouter);
/* eslint-disable */
import loginScreen from "../screens/authScreen/LoginScreen.vue";
import loginScreenMobile from "../screens/authScreen/LoginScreenMobile.vue";
import loginScreenAdminMobile from "../screens/authScreen/LoginScreenAdminMobile.vue";
import loginScreenAdmin from "../screens/authScreen/LoginScreenAdmin.vue";

function isMobile() {
  return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

const LoginWrapper = {
  render(h) {
    return h(isMobile() ? loginScreenMobile : loginScreen);
  },
};

const LoginAdminWrapper = {
  render(h) {
    return h(isMobile() ? loginScreenAdminMobile : loginScreenAdmin);
  },
};

// Helper function to check if user is properly authenticated
function isAuthenticated() {
  try {
    const auth = SecureStorage.getItem('auth');
    // Consider user authenticated if they have auth object with role
    return !!(auth && (auth.authorized || auth.role));
  } catch {
    return false;
  }
}

// Public routes
const publicRoutes = ['/', '/login-admin', '/reset-password'];

const routes = [
  // {
  //   path: "/",
  //   title: "Offline",
  //   name: "Offline",
  //   component: () => import("../views/Offline.vue"),
  // },
  {
    path: "/",
    title: "Login",
    name: "Login",
    // component: () => import("../screens/authScreen/LoginScreen.vue"),
    component: LoginWrapper,
  },
  {
    path: "/login-admin",
    title: "Login Admin",
    name: "Login Admin",
    component: LoginAdminWrapper,
  },
  {
    path: "/reset-password",
    title: "Reset Password",
    name: "ResetPassword",
    component: () => import("../screens/authScreen/ResetPassword.vue"),
  },
  {
    path: "/login/signup/bis/me",
    title: "My Buyer's Information Sheet",
    name: "My Buyer's Information Sheet",
    component: () =>
      import("../screens/authScreen/SignUpScreen/components/BISMe.vue"),
  },
  {
    path: "/login/signup/bis/co",
    title: "Co Buyer's Information Sheet",
    name: "Co Buyer's Information Sheet",
    component: () =>
      import("../screens/authScreen/SignUpScreen/components/BISCo.vue"),
  },
  // {
  //     path: "/bis",
  //     title: "Buyer's Information Sheet",
  //     name: "Buyer's Information Sheet",
  //     component: () =>
  //         import ("../components/BuyersInformationSheet.vue"),
  // },

  {
    path: "/property_selection",
    title: "Property Selection",
    name: "Property Selection",
    component: () =>
      import("../screens/customerPropertyScreen/PropertySelectionScreen.vue"),
  },

  {
    path: "/admin",
    title: "Admin Page",
    name: "Admin Page",
    component: () => import("../screens/adminScreen/LandingScreen.vue"),
  },
  {
    path: "/admin/admin-dashboard-screen",
    title: "Admin Dashboard",
    name: "Admin Dashboard Screen",
    component: () =>
      import("../screens/adminScreen/adminDashboard/AdminDashboardScreen"),
    children: [
      {
        path: "unassigned-tickets",
        meta: { title: "Open Tickets", id: 0 },
        name: "unassigned-tickets",
        component: () =>
          import(
            "../screens/adminScreen/unassignedTickets/UnassignedTicketsTable"
          ),
      },
      {
        path: "north",
        meta: { title: "North", id: 7 },
        name: "north",
        component: () => import("../screens/adminScreen/north/NorthTable"),
      },

      {
        path: "south",
        meta: { title: "South", id: 8 },
        name: "south",
        component: () => import("../screens/adminScreen/south/SouthTable"),
      },
      {
        path: "vertical",
        meta: { title: "Vertical", id: 9 },
        name: "vertical",
        component: () =>
          import("../screens/adminScreen/vertical/VerticalTable"),
      },
      {
        path: "updated-bis",
        meta: { title: "Updated Bis", id: 10 },
        name: "updated-bis",
        component: () =>
          import("../screens/adminScreen/updatedBis/UpdatedBisTable"),
      },
      {
        path: "closed-bis",
        meta: { title: "Closed Bis", id: 100 },
        name: "closed-bis",
        component: () =>
          import("../screens/adminScreen/closedBis/ClosedBisTable"),
      },
      {
        path: "appointment-request",
        meta: { title: "Appointment Request" },
        name: "appointment-request",
        component: () =>
          import(
            "../screens/adminScreen/appointmentRequest/AppointmentRequestTable"
          ),
      },
      {
        path: "closed-tickets",
        meta: { title: "Closed Tickets", id: 12 },
        name: "closed-tickets",
        component: () =>
          import("../screens/adminScreen/closedTickets/ClosedTicketsTable"),
      },
      {
        path: "assigned-tickets",
        meta: { title: "Assigned Tickets" },
        name: "assigned-tickets",
        component: () =>
          import("../screens/adminScreen/assignedTickets/AssignedTicketsTable"),
      },
      {
        path: "watch-list",
        meta: { title: "Watch List", id: 99 },
        name: "watch-list",
        component: () =>
          import("../screens/adminScreen/watchList/WatchListTable"),
      },
      {
        path: "email-archive",
        meta: { title: "Email Archive" },
        name: "email-archive",
        component: () =>
          import("../screens/adminScreen/emailArchive/emailArchive"),
      },
      {
        path: "create-ticket",
        meta: { title: "Create Ticket" },
        name: "create-ticket",
        component: () =>
          import("../screens/adminScreen/createTicket/CreateTicketTable"),
      },
    ],
  },
  {
    path: "/admin/analytics",
    title: "Analytics",
    name: "Analytics",
    component: () => import("../screens/adminScreen/AnalyticsScreen.vue"),
  },

  {
    path: "/client-dashboard",
    title: "Client Dashboard",
    name: "client-dashboard",
    component: () =>
      import("../screens/adminScreen/components/ClientDataTable.vue"),
  },
  {
    path: "/home",
    title: "Home Page",
    name: "Client Home Page",
    component: () => import("../common/HomeRouter.vue"),
    children: [
      {
        path: "my-account",
        title: "My Account",
        name: "My Account",
        component: () =>
          import("../screens/myAccountScreen/MyAccountScreen.vue"),
      },
      {
        path: "settings",
        meta: { title: "Settings" },
        name: "Settings",
        component: () => import("@/screens/settingsScreen/SettingsScreen.vue"),
        children: [
          {
            path: "update-contract-numbers",
            meta: { title: "Update Contract Numbers" },
            name: "Update Contract Numbers",
            component: () =>
              import(
                "@/screens/settingsScreen/updateContractNumber/UpdateContractNumber.vue"
              ),
          },
          {
            path: "csv-validator",
            meta: { title: "CSV Validator" },
            name: "Settings-CSV-VALIDATOR",
            component: () =>
              import("@/screens/settingsScreen/csvSettings/CsvValidator.vue"),
          },
          {
            path: "departments",
            meta: { title: "Department Settings" },
            name: "Settings-Departments",
            component: () =>
              import(
                "@/screens/settingsScreen/DepartmentSettingsScreen/DepartmentsSettings.vue"
              ),
          },
          {
            path: "customers",
            meta: { title: "Customers" },
            name: "Customers",
            component: () => import("@/screens/customers/CustomersIndex.vue"),
          },
          {
            path: "email-match",
            meta: { title: "Email Match" },
            name: "Email Match",
            component: () => import("@/screens/customers/EmailMatch.vue"),
          },
          {
            path: "users",
            meta: { title: "User Settings" },
            name: "Settings-Users",
            component: () =>
              import(
                "../screens/settingsScreen/UserSettingsScreen/UserSettings.vue"
              ),
          },
          {
            path: "csv",
            meta: { title: "CSV Uploader" },
            name: "Settings-CSV-Uploader",
            component: () =>
              import("../screens/settingsScreen/csvUploader/FileUpload.vue"),
          },
          {
            path: "csv",
            meta: { title: "CSV Settings" },
            name: "Settings-CSV",
            component: () =>
              import("../screens/settingsScreen/csvSettings/CsvSettings"),
          },
          {
            path: "faq",
            meta: { title: "FAQ CONTENT" },
            name: "Settings-FAQ",
            // component: () => import('@/pages/faq/html/index'),
            component: () =>
              import(
                "../screens/settingsScreen/FaqSettingsScreen/components/html/index.vue"
              ),
          },
        ],
      },
      {
        path: "statement-of-account",
        title: "Statement of Account",
        meta: {
          classification_id: 9,
          department_id: 10,
        },
        name: "Statement of Account",
        component: () =>
          import("../screens/statementOfAccountScreen/SoaScreen.vue"),
      },
      {
        path: "customer-dashboard",
        title: "Customer Dashboard",
        name: "Customer Dashboard",
        component: () =>
          import(
            "../screens/customerLandingScreen/components/CustomerDatatable.vue"
          ),
      },
      {
        path: "admin-dashboard",
        title: "Admin Dashboard",
        name: "Admin Dashboard",
        component: () => import("../screens/adminScreen/DashboardScreen.vue"),
      },
      {
        path: "dashboard",
        title: "Home - Dashboard / Main Menu",
        name: "Home Dashboard",
        component: () =>
          import("../screens/customerLandingScreen/CustomerLandingScreen.vue"),
      },
      // {
      // 	path: 'inquiry',
      // 	title: 'Submit Document / Submit Request',
      // 	name: 'Submit Documents / Submit a Request',
      // 	component: () =>
      // 		import('../screens/customerInquiryScreen/CustomerInquiryScreen'),
      // },
      // tree
      {
        path: "bills-payment",
        meta: { title: "Billing Payments" },
        name: "Billing Payments",
        component: () =>
          import("@/screens/buyersGuideScreen/BillsPaymentTreeView"),
      },
      // tree
      {
        path: "buyers-guide-front-page",
        meta: { title: "Buyer's Guide" },
        name: "Buyers Guide Front Page",
        component: () => import("@/screens/buyersGuideScreen/FrontPage.vue"),
      },
      {
        path: "buyers-guide",
        title: "Buyer's Guide",
        name: "Buyers Guide",
        component: () =>
          import("@/screens/buyersGuideScreen/BuyersGuideScreen"),
      },
      {
        path: "buyers-guide-main",
        name: "buyers-guide-main",
        meta: { title: "Buyer's Guide" },
        component: () =>
          import(
            "@/screens/buyersGuideScreen/scrollVersion/BuyersGuideMain.vue"
          ),
      },
      {
        path: "buyers-guide-billing-payments",
        name: "buyers-guide-billing-payments",
        meta: { title: "Buyer's Guide Billing Payments" },
        component: () =>
          import(
            "../screens/buyersGuideScreen/scrollVersion/screens/billingPayments/BillingPaymentsScreen.vue"
          ),
      },
      {
        path: "buyers-guide-financing-scheme-payments",
        meta: { title: "Financing Scheme" },
        name: "buyers-guide-financing-scheme-payments",
        meta: { title: "Buyer's Financing Scheme" },
        component: () =>
          import(
            "../screens/buyersGuideScreen/scrollVersion/screens/financingScheme/FinancingScheme-Main.vue"
          ),
      },
      {
        path: "buyers_guide_content",
        title: "Buyer's Guide Content",
        name: "buyers_guide_content",
        component: () =>
          import("@/screens/buyersGuideScreen/BillingPaymentsScreen"),
      },
      {
        path: "buyers-guide-move-in",
        meta: { title: "Move-in Turnover" },
        name: "buyers-guide-move-in",
        meta: { title: "Buyer's Move-in/Turnover Requirements " },
        component: () =>
          import(
            "../screens/buyersGuideScreen/scrollVersion/screens/moveinTurnover/MoveinTurnover-Main.vue"
          ),
      },
      {
        path: "buyers-guide-title-transfer",
        meta: { title: "Title Transfer" },
        name: "buyers-guide-title-transfer",
        meta: { title: "Buyer's Title Transfer" },
        component: () =>
          import(
            "../screens/buyersGuideScreen/scrollVersion/screens/titleTransfer/TitleTransferMain.vue"
          ),
      },
      // src/screens/buyersGuideScreen/
      {
        // path: "faq/:service_id",
        path: "faq",
        title: "FAQ",
        name: "FAQ",
        component: () => import("../screens/faqScreen/FaqScreen.vue"),
      },
      {
        path: "my-documents",
        title: "My Documents",
        name: "My Documents",
        component: () =>
          import("../screens/myDocumentsScreen/MyDocumentsScreen.vue"),
      },
      {
        path: "request-documents",
        meta: {
          title: "Request for Documents",
          subject: "Request for Documents",
          header_title: "Scanned Documents",
          classification_id: 1,
          department_id: 10,
        },
        name: "Request for Documents",
        component: () =>
          import(
            "../screens/myDocumentsScreen/RequestDocumentScreen/index.vue"
          ),
      },
      {
        path: "submit-documents",
        title: "Submit Documents",
        name: "Submit Documents",
        component: () =>
          import(
            "../screens/myDocumentsScreen/SubmitDocumentsScreen/index.vue"
          ),
      },
      {
        path: "book_appointment",
        title: "Book an Appointment",
        name: "Book an Appointment",
        component: () => import("../screens/appointments/HomeViewStepper.vue"),
      },
      {
        path: "book_appointment/calendar",
        title: "Book an Appointment - Calendar",
        name: "Calendar",
        component: () => import("../screens/appointments/screens/Calendar.vue"),
      },
      {
        path: "book_appointment/time_table",
        title: "Book an Appointment - Time Table",
        name: "TimeTable",
        component: () =>
          import("../screens/appointments/screens/TimeTable.vue"),
      },
      {
        path: "book_appointment/summary",
        title: "Book an Appointment - Summary",
        name: "AppointmentSummary",
        component: () => import("../screens/appointments/screens/Summary.vue"),
      },
      {
        path: "book_appointment/note",
        title: "Book an Appointment - Note",
        meta: {
          subject: "Book an Appointment",
          classification_id: 6,
          title: "Book an Appointment",
          department_id: 10,
        },
        name: "AppointmentNote",
        component: () => import("../screens/appointments/screens/Note.vue"),
      },
      // {
      // 	path: 'submit-documents',
      // 	title: 'Submit Document',
      // 	name: 'submit-documents',
      // 	meta: {
      // 		title: 'Submit Document',
      // 	},
      // 	component: () =>
      // 		import('@/screens/customerInquiryScreen/SubmitDocumentsForm'),
      // },
      {
        path: "submit-request",
        title: "Request",
        name: "submit-request",
        meta: {
          title: "Submit Request",
        },
        component: () =>
          import("../screens/submitRequestForm/SubmitRequestScreen.vue"),
      },
      {
        path: "waive-penalties",
        title: "Waive Penalties",
        name: "waive-penalties",
        meta: {
          title: "Wave Penalties",
        },
        component: () =>
          import("../screens/waivePenaltiesScreen/WaivePenaltiesScreen.vue"),
      },
      {
        path: "transfer-property",
        title: "Transfer Property",
        name: "transfer-property",
        meta: {
          title: "Transfer Property",
        },
        component: () =>
          import(
            "../screens/transferPropertyScreen/TransferPropertyScreen.vue"
          ),
      },

      {
        // transfer-property-form
        path: "transfer-property-form",
        name: "transfer-property-form",
        meta: {
          title: "Transfer Property Form",
          subject: "Transfer Property",
          classification_id: 10,
          department_id: 10,
        },
        component: () =>
          import("../screens/transferPropertyScreen/TransferPropertyForm.vue"),
      },
      {
        // upgrade-property-form
        path: "upgrade-property-form",
        meta: {
          title: "Upgrade Property Form",
          subject: "Upgrade Property",
          classification_id: 10,
          department_id: 10,
        },
        name: "upgrade-property-form",

        component: () =>
          import("../screens/transferPropertyScreen/UpgradePropertyForm.vue"),
      },
      {
        // pull-out-check
        path: "pull-out-check",
        title: "Pull Out Check",
        name: "pull-out-check",
        meta: {
          title: "Pull Out Check",
        },
        component: () =>
          import("../screens/pullOutChecksScreen/PullOutChecksScreen.vue"),
      },
      {
        // refund
        path: "refund",
        title: "Refund",
        name: "refund",
        meta: {
          title: "Refund",
        },
        component: () => import("../screens/refundScreen/RefundScreen.vue"),
      },
      {
        // issuance
        path: "issuance",
        title: "Issuance",
        name: "issuance",
        meta: {
          title: "Issuance",
          subject: "Issuance of move-in clearance",
          classification_id: 10,
          request_type_id: 5,
        },
        component: () => import("../screens/issuanceScreen/IssuanceScreen.vue"),
      },
      {
        // change-payment-terms
        path: "change-payment-terms",
        title: "Change Payment Terms",
        name: "change-payment-terms",
        meta: {
          title: "Change Payment Terms",
          subject: "Change Payment Terms",
          classification_id: 10,
          request_type_id: 6,
          department_id: 10,
        },
        component: () =>
          import(
            "../screens/changePaymentTermsScreen/ChangePaymentTermsScreen.vue"
          ),
      },
      {
        // cancel-contract
        path: "cancel-contract",
        title: "Cancel Contract",
        name: "cancel-contract",
        meta: {
          title: "Cancel Contract",
        },
        component: () =>
          import("../screens/cancelContractScreen/CancelContractScreen.vue"),
      },
      {
        // transfer-right
        path: "transfer-right",
        title: "Transfer Right",
        name: "transfer-right",
        meta: {
          title: "Transfer Right",
          subject: "Transfer Right",
          classification_id: 10,
          request_type_id: 8,
          department_id: 10,
        },
        component: () =>
          import("../screens/transferRightScreen/TransferRightScreen.vue"),
      },
      {
        path: "payment-portal",
        title: "Payment Schedule",
        name: "Payment Portal",
        component: () => import("../views/Forms/PaymentSchedule.vue"),
      },
      {
        path: "request-inquiry",
        title: "Request/Inquiry",
        name: "Request/Inquiry",
        component: () =>
          import("../screens/requestInquiryScreen/RequestInquiryScreen.vue"),
      },
      {
        path: "same-financing-scheme",
        title: "Same financing scheme",
        name: "same-financing-scheme",
        component: () =>
          import(
            "../screens/changePaymentTermsScreen/screens/sameFinancingScheme/SameFinancingSchemeScreen.vue"
          ),
      },
      {
        path: "full-payment-pre-terminate",
        title: "Full payment/Pre-terminate",
        name: "full-payment-pre-terminate",
        component: () =>
          import(
            "../screens/changePaymentTermsScreen/screens/fullPaymentPreTerminate/FullPaymentPreTerminateScreen.vue"
          ),
      },
      {
        path: "bank-to-inhouse-financing",
        title: "Bank to in-house financing",
        name: "bank-to-inhouse-financing",
        component: () =>
          import(
            "../screens/changePaymentTermsScreen/screens/bankToInhouseFinancing/BankToInhouseFinancingScreen.vue"
          ),
      },
      {
        path: "not-fully-paid",
        title: "Not Fully Paid",
        name: "not-fully-paid",
        component: () =>
          import(
            "../screens/transferRightScreen/screens/fullyPaid/FullyPaidScreen.vue"
          ),
      },
      {
        path: "fully-paid",
        title: "Fully Paid",
        name: "fully-paid",
        component: () =>
          import(
            "../screens/transferRightScreen/screens/notFullyPaid/NotFullPaidScreen.vue"
          ),
      },
    ],
  },

  {
    path: "/admin/edit_page",
    title: "Edit Page",
    name: "Edit Page",
    component: () => import("../components/EditPage/EditPage"),
    children: [
      {
        path: "services/:service_id",
        name: "Edit Service",
        component: () => import("../components/EditPage/EditServices"),
      },
    ],
  },
];

// Create router instance with your routes
const router = new VueRouter({
  mode: "history",
  base: process.env.NODE_ENV === "production" ? "/" : "/",
  routes,
});

// Update the router guard
router.beforeEach((to, from, next) => {
  try {
    const auth = SecureStorage.getItem('auth');
    const isPublicRoute = publicRoutes.includes(to.path);

    // Handle public routes
    if (isPublicRoute) {
      if (isAuthenticated()) {
        // Redirect to appropriate dashboard if authenticated
        const dashboardPath = auth.role === 'admin' 
          ? '/admin/admin-dashboard-screen/unassigned-tickets'
          : '/home/dashboard';
        next(dashboardPath);
      } else {
        next();
      }
      return;
    }

    // Handle protected routes
    if (!isAuthenticated()) {
      // Redirect to appropriate login based on the last attempted path
      const loginPath = to.path.includes('/admin') ? '/login-admin' : '/';
      next(loginPath);
      return;
    }

    // Allow access to protected route
    next();

  } catch (error) {
    console.error('Router guard error:', error);
    SecureStorage.removeItem('auth');
    next('/');
  }
});

export default router;
